import appSchema from '../../schema/appSchema.js';
import { getArgumentValue } from '../getArgumentValue.js';

const isDefaultOperator = (operator) => {
  return appSchema?.api?.filters?.operators?.some((n) => n.value.toLowerCase() === operator.toLowerCase());
};

export const validateConditional = async ({ condition, name = 'condition', status }) => {
  const field = await getArgumentValue({ arg: condition?.field, opts: { format: 'human' } });
  const operator = condition?.operator?.toLowerCase();
  const value = Array.isArray(condition?.value) //
    ? await Promise.all(condition?.value?.map((v) => getArgumentValue({ arg: v, opts: { format: 'human' } })))
    : await getArgumentValue({ arg: condition?.value, opts: { format: 'human' } });

  if (!field) {
    return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${name} field` };
  }

  const isDefault = isDefaultOperator(operator);
  if (!isDefault) {
    return { status: 'valid' };
  }

  if (!operator) {
    return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${name} operator` };
  }

  if (!['exist', 'nexist', 'empty', 'nempty'].includes(operator)) {
    const isValueEmpty = value === null || value === undefined || value === '' || (Array.isArray(value) && (value.length === 0 || value.every((v) => v === null || v === undefined || v === '')));
    if (isValueEmpty) {
      return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${name} value` };
    }
  }

  return { status: 'valid' };
};
